import { LDFlagValueTypes, LDFlags } from '../constants/flags';
import {
  AFFILIATE_ENTRY,
  ALL_DONE,
  COBUYER_LOAN_APPLICATION,
  DASHBOARD,
  FLOW_ENTRY,
  GETTING_STARTED,
  LOAN_APPLICATION,
  MKT_HOME,
  NEXT_STEPS,
  PAYOFF_INSTRUCTIONS,
  SELL_DETAILS,
} from '../constants/urls';

export const defaultBack = () => '';
export const defaultNext = () => '';

export type BackOptions = {
  hasCobuyer?: boolean;
  isGapOffered?: boolean;
  redirect?: boolean;
  skipPayoffAccordion?: boolean;
  wantsToSell?: boolean;
};

export type NextOptions = {
  isGapOffered?: boolean;
  isBuyout?: boolean;
  isJourneyFinished?: boolean;
  hasPackageOptions?: boolean;
  isCobuyerSameResidence?: boolean;
  hasCobuyer?: boolean;
  isAdditionalInfoNeeded?: boolean;
  isPayoffUploaded?: boolean;
  skipPayoffAccordion?: boolean;
  passwordlessDashboardAccess?: boolean;
  wantsToSell?: boolean;
};

type CheckFlag = <T extends LDFlags>(flag: T) => LDFlagValueTypes[T];

export type Step = {
  url: string;
  back: (options: BackOptions, checkFlag: CheckFlag) => string;
  next: (options: NextOptions, checkFlag: CheckFlag) => string;
};

export const itineraries: Step[] = [
  {
    url: FLOW_ENTRY,
    back: defaultBack,
    next: () => GETTING_STARTED,
  },
  {
    url: AFFILIATE_ENTRY,
    back: defaultBack,
    next: () => NEXT_STEPS,
  },
  {
    url: DASHBOARD,
    back: defaultBack,
    next: () => GETTING_STARTED,
  },
  {
    url: PAYOFF_INSTRUCTIONS,
    back: () => GETTING_STARTED,
    next: ({ wantsToSell }) => (wantsToSell ? SELL_DETAILS : LOAN_APPLICATION),
  },
  {
    url: LOAN_APPLICATION,
    back: ({ skipPayoffAccordion }) =>
      skipPayoffAccordion ? GETTING_STARTED : PAYOFF_INSTRUCTIONS,
    next: ({ hasCobuyer }) => {
      if (hasCobuyer) {
        return COBUYER_LOAN_APPLICATION;
      }

      return NEXT_STEPS;
    },
  },
  {
    url: SELL_DETAILS,
    back: ({ skipPayoffAccordion }) =>
      skipPayoffAccordion ? GETTING_STARTED : PAYOFF_INSTRUCTIONS,
    next: () => NEXT_STEPS,
  },
  {
    url: COBUYER_LOAN_APPLICATION,
    back: () => LOAN_APPLICATION,
    next: () => NEXT_STEPS,
  },
  {
    url: NEXT_STEPS,
    back: ({ wantsToSell }) => (wantsToSell ? SELL_DETAILS : LOAN_APPLICATION),
    next: ({ passwordlessDashboardAccess }) => (passwordlessDashboardAccess ? DASHBOARD : ALL_DONE),
  },
  {
    url: ALL_DONE,
    back: () => NEXT_STEPS,
    next: defaultNext,
  },
  {
    url: GETTING_STARTED,
    back: () => MKT_HOME,
    next: ({ skipPayoffAccordion, wantsToSell }) => {
      if (skipPayoffAccordion) {
        return wantsToSell ? SELL_DETAILS : LOAN_APPLICATION;
      }
      return PAYOFF_INSTRUCTIONS;
    },
  },
];
